/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./NewAdminDialog.vue?vue&type=template&id=74a2f962"
import script from "./NewAdminDialog.vue?vue&type=script&lang=js"
export * from "./NewAdminDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a2f962')) {
      api.createRecord('74a2f962', component.options)
    } else {
      api.reload('74a2f962', component.options)
    }
    module.hot.accept("./NewAdminDialog.vue?vue&type=template&id=74a2f962", function () {
      api.rerender('74a2f962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admins/NewAdminDialog.vue"
export default component.exports